import Subscription from '_core_ext/components/forms/Subscription';
import page from '_core_ext/page';

export default class RegistrationForm extends Subscription {
    init() {
        super.init();
        this.expandReadMore();
    }

    expandReadMore() {
        var showReadMoreRegistrationBlock = $('.show-read-more-registration .form-row_label.js-input-label');
        if (showReadMoreRegistrationBlock) {
            var readMoreseo = Resources.VIEWMORE;
            var readLessseo = Resources.VIEWLESS;
            $('<a href="javascript:void(0);" class="read-more-registration"><span class="read-more-text-registration">' + readMoreseo + '</span></a>').insertAfter($(showReadMoreRegistrationBlock));
            var showReadMoreRegistration = $(".show-read-more-registration");
            var readMoreRegistration = $(".read-more-registration");
            var readMoreTextRegistration = readMoreRegistration.find('.read-more-text-registration');
            readMoreRegistration.click(function () {
                    if(!readMoreRegistration.hasClass('read-less')){
                        readMoreTextRegistration.text(readLessseo);
                        $(readMoreRegistration).addClass('read-less');
                        $(showReadMoreRegistration).addClass('read-less');
                    }else{
                        readMoreTextRegistration.text(readMoreseo);
                        $(readMoreRegistration).removeClass('read-less');
                        $(showReadMoreRegistration).removeClass('read-less');
                    }
                });
        }
    }

    onSubmitSuccess(response) {
        this.$el.trigger('newsletterSubscriptionCb.success', [this.$el]);
        page.redirect(response.redirectUrl);
    }
}